import { useParams } from "react-router-dom";

const useEpisodeId = () => {
  const { id } = useParams();

  return id;
};

export default useEpisodeId;
